module.exports = __webpack_public_path__ + "static/img/pages.0df7c40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontProJect/fangzhou/pages.png
// module id = Sq+U
// module chunks = 1